
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinpunecorporate() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pune for Corporate ',
        heading: 'Amruta Travels: Urbania On Rent in Pune for Corporate',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Pune for Corporate Travel, providing a premium and comfortable transportation solution tailored for business needs. Whether you are organizing executive meetings, team outings, conferences, or airport transfers, our fleet of well-maintained Force Urbania vans ensures a smooth and professional journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


  "services": [
    {
      "name": "Force Urbania on Rent in Pune for Corporate",
      "description": "Amruta Travels offers Force Urbania vans on rent in Pune tailored for corporate transport. Whether it's daily office commutes, executive transfers, or team off-sites, our 13- and 17-seater Urbania vehicles ensure premium comfort, punctuality, and professional service."
    },
    {
      "name": "Force Urbania 13 Seater on Rent in Pune",
      "description": "Rent a 13-seater Force Urbania from Amruta Travels in Pune for small group outings, corporate travel, or personal tours. Enjoy AC comfort, high ceilings, and luxury-style seating with trained chauffeurs and flexible rental options."
    },
    {
      "name": "Force Urbania 17 Seater on Rent in Pune",
      "description": "Need a 17-seater for group travel? Amruta Travels provides Force Urbania 17-seater rentals in Pune, ideal for school picnics, corporate day trips, weddings, and Pune Darshan with ample space and comfort."
    },
    {
      "name": "Force Urbania Rent Pune",
      "description": "Looking to rent a Force Urbania in Pune? Amruta Travels offers budget-friendly and luxurious options for short-term and long-term travel needs. Whether for events or business use, enjoy smooth rides with expert drivers and all necessary amenities."
    },
    {
      "name": "Urbania on Rent in Pune for Event",
      "description": "Planning an event in Pune? Rent a stylish Force Urbania from Amruta Travels for guest pickups, artist transport, or logistics. Our event-specific service ensures reliability, cleanliness, and timely drop-offs with experienced drivers."
    },
    {
      "name": "Force Urbania for Rent Near Me",
      "description": "Find a Force Urbania for rent near your location in Pune with Amruta Travels. We cover all localities and provide prompt service for airport transfers, weddings, or outstation trips with flexible per km pricing and top-rated drivers."
    },
    {
      "name": "Force Urbania 17 Seater for Rent",
      "description": "Amruta Travels offers 17-seater Force Urbania rentals for group travel, school field trips, business events, and long-distance tours. With spacious interiors, pushback seats, and air conditioning, enjoy safe and smooth journeys anywhere from Pune."
    },
    {
      "name": "Tempo Traveller Urbania on Rent",
      "description": "Get a luxury Force Urbania Tempo Traveller on rent with Amruta Travels in Pune. Designed for style and efficiency, these vans are perfect for mid-sized group travel with AC, ample legroom, and a comfortable ride even on hilly routes."
    },
    {
      "name": "Urbania Bus on Rent for Corporate Employees",
      "description": "Ensure convenient and punctual employee transport with Urbania buses from Amruta Travels. Our well-maintained 13–17 seater vehicles are ideal for daily staff pick-up and drop-off with monthly and customized plans."
    },
    {
      "name": "Urbania Bus On Rent for Corporate Outings",
      "description": "Amruta Travels provides Urbania mini-buses for corporate outings in Pune. Whether it's a team-building trip, retreat, or seminar travel, our Urbania rentals offer AC comfort, professional drivers, and customizable packages."
    },
    {
      "name": "Urbania Bus on Rent in Pune for Party Outings",
      "description": "Heading out for a celebration? Rent an Urbania bus from Amruta Travels for birthday parties, bachelor trips, or weekend events in and around Pune. Spacious seating and sound AC systems ensure a comfortable ride for the whole group."
    },
    {
      "name": "Urbania Bus on Rent for Monthly Basis in Pune",
      "description": "Need a long-term Urbania rental? Amruta Travels offers monthly Urbania bus rentals in Pune for corporate employee travel, school use, and more. Get consistent service, fixed rates, and fully sanitized vehicles with trained drivers."
    },
    {
      "name": "Urbania on Rent for Pune to Mahabaleshwar",
      "description": "Planning a trip to Mahabaleshwar? Book a Force Urbania from Amruta Travels for a scenic and relaxing Pune-to-Mahabaleshwar journey. Our vans are ideal for family getaways, group travel, and tourism with plenty of luggage space and reliable comfort."
    },
    {
      "name": "13 and 17 Seater Urbania Luxury Mini Bus on Rent in Pune",
      "description": "Amruta Travels offers luxury Urbania mini buses (13 and 17 seaters) for rent in Pune. Ideal for VIP guests, executives, or high-end travel requirements, these vans feature elegant interiors, AC, and professional service at affordable rates."
    }
  ],
  "tableData": [
    ["Force Urbania on Rent in Pune for Corporate", "Force Urbania 13 Seater on Rent in Pune"],
    ["Force Urbania 17 Seater on Rent in Pune", "Force Urbania Rent Pune"],
    ["Urbania on Rent in Pune for Event", "Force Urbania for Rent Near Me"],
    ["Force Urbania 17 Seater for Rent", "Tempo Traveller Urbania on Rent"],
    ["Urbania Bus on Rent for Corporate Employees", "Urbania Bus On Rent for Corporate Outings"],
    ["Urbania Bus on Rent in Pune for Party Outings", "Urbania Bus on Rent for Monthly Basis in Pune"],
    ["Urbania on Rent for Pune to Mahabaleshwar", "13 and 17 Seater Urbania Luxury Mini Bus on Rent in Pune"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Professional Urbania Rental Services for Corporate Travel in Pune",
    "WhyChoosedescription": "Amruta Travels offers premium Urbania vans on rent in Pune, specially suited for corporate travel. Whether it's daily employee transport, business meetings, off-site visits, or airport transfers, our Urbania vans deliver professional-grade comfort and reliability for business needs."
  },
  {
    "WhyChooseheading": "Executive-Class Comfort for Business Commuting",
    "WhyChoosedescription": "Urbania vans feature plush seating, ample legroom, air conditioning, and smooth suspension, ensuring a comfortable ride for your executives and teams. The vehicle’s modern interiors provide a relaxed and professional environment for seamless travel between corporate destinations."
  },
  {
    "WhyChooseheading": "On-Time, Reliable Transportation for Your Team",
    "WhyChoosedescription": "Punctuality is key in corporate travel. Our Urbania vans are operated by trained drivers who prioritize timely pick-ups and drop-offs. With GPS tracking and efficient route planning, your employees and clients can depend on us for a stress-free journey."
  },
  {
    "WhyChooseheading": "Tailored Rental Plans for Corporate Clients",
    "WhyChoosedescription": "We offer flexible rental packages designed for corporate needs—daily, weekly, or monthly bookings at competitive rates. Our custom plans can accommodate everything from one-time event transportation to long-term employee commute contracts."
  },
  {
    "WhyChooseheading": "Fully Equipped Vans for Business-Class Travel",
    "WhyChoosedescription": "Each Urbania van comes with modern business-travel amenities like charging ports, air conditioning, reading lights, and ample luggage space. These features ensure that passengers can stay connected and comfortable while traveling to work or corporate events."
  },
  {
    "WhyChooseheading": "Corporate Billing and Transparent Invoicing",
    "WhyChoosedescription": "Amruta Travels offers corporate clients professional billing with GST-compliant invoices and clear, transparent pricing. There are no hidden charges—our corporate clients receive detailed billing suitable for company accounts and reimbursement procedures."
  },
  {
    "WhyChooseheading": "Dedicated Account Support and Priority Service",
    "WhyChoosedescription": "Our corporate clients receive dedicated support for faster bookings, priority dispatch, and customized service. A single point of contact ensures all your transportation needs are handled smoothly, making coordination easier for HR and admin teams."
  },
  {
    "WhyChooseheading": "Trusted by Companies Across Pune",
    "WhyChoosedescription": "We are a preferred partner for multiple businesses in Pune for their staff and executive travel needs. Our reputation for reliable service, clean vehicles, and courteous drivers makes us the go-to choice for professional Urbania rentals in the city."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania for corporate travel in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Force Urbania on rent in Pune specifically for corporate travel. It’s a perfect choice for business events, team outings, airport transfers, and corporate meetings.',
  },
  {
    question: 'Why is the Force Urbania suitable for corporate travel?',
    answer: 'The Force Urbania is designed for comfort and professionalism. It features air conditioning, executive-style seating, ample legroom, luggage space, and a smooth ride—ideal for corporate clients.',
  },
  {
    question: 'What seating capacities are available for corporate Urbania rentals?',
    answer: 'We offer Urbania minibuses in 13-seater and 17-seater configurations, making them suitable for small to medium-sized corporate groups.',
  },
  {
    question: 'Is a professional driver included with the corporate Urbania rental?',
    answer: 'Yes, all Force Urbania rentals include a professional, uniformed driver who is punctual, well-trained, and experienced in corporate transport.',
  },
  {
    question: 'Can I rent an Urbania for corporate airport transfers?',
    answer: 'Absolutely! The Force Urbania is an excellent choice for airport pickups and drop-offs, ensuring your team or clients travel in comfort and style.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania for corporate use in Pune?',
    answer: 'Pricing depends on seating capacity, duration, and distance. Typically, rates start from ₹35/km for a 13-seater and ₹38/km for a 17-seater. For local travel, packages are also available.',
  },
  {
    question: 'Are the Urbania vehicles sanitized and well-maintained?',
    answer: 'Yes, all our Force Urbania vehicles are regularly maintained and sanitized before every trip to ensure top-notch hygiene, safety, and a premium experience.',
  },
  {
    question: 'How can I book a Force Urbania for my corporate event in Pune?',
    answer: 'Booking is simple—just visit our website or contact our team by phone. Provide your corporate travel details, and we’ll handle the rest, ensuring a seamless rental experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    role: 'HR Manager, Pune',
    text: 'We rented a Force Urbania for a corporate conference. The vehicle was executive-class, clean, and punctual. Amruta Travels provided an excellent experience from start to finish.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Shah',
    role: 'Operations Head, IT Firm',
    text: 'For our team outing, the Urbania was a great choice. Very comfortable, professional driver, and reliable service. Highly recommended for any corporate travel needs.',
    rating: 5,
  },
];










































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune for Corporate",
  "image": "https://bushireinpune.com/assets/images/urbania-on-rent-corporate-pune.jpg", // Update with the actual image URL
  "description": "Amruta Travels offers Urbania buses on rent in Pune for corporate events, employee outings, parties, and more. Rent a Force Urbania 13-seater or 17-seater luxury mini bus for your corporate needs in Pune. Affordable rental options available for monthly, one-time, or outstation trips like Pune to Mahabaleshwar.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500", // Adjust the price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-on-rent-corporate-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania On Rent in Pune for Corporate | Luxury Mini Bus Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent Force Urbania 13-seater and 17-seater luxury mini buses in Pune for corporate events, employee outings, parties, and more. Affordable rental for monthly or one-time needs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpunecorporate;